import React, { FC, ReactNode } from 'react';
import { Card } from 'antd';
import styled from 'styled-components';

interface StepWrapperProps {
  title?: string;
  children?: ReactNode;
}

const StepWrapper: FC<StepWrapperProps> = ({ children, title }) => {
  return (
    <StepCard
      title={title}
      bodyStyle={{ padding: 16 }}
      headStyle={{ padding: '0px 16px' }}
    >
      {children}
    </StepCard>
  );
};

const StepCard = styled(Card)`
  width: 100%;
  margin-left: 12px;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
`;

export const StepContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default StepWrapper;
